import Route from '@ember/routing/route';

export default class ScreensSchedulesScheduleRoute extends Route {
  model(): void {
    return;
  }
}
